import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import WrongAnswerNote from './pages/WrongAnswerNote';
import RecordList from './pages/RecordList';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/register" element={<WrongAnswerNote />} />
        <Route path="/records" element={<RecordList />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
